// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Licenses_container__812FI {
  position: relative;
  z-index: 2;
  margin: 68rem auto 162rem;
  width: 100%;
  padding: 0 48px;
}
@media (min-width: 1825px) {
  .Licenses_container__812FI {
    width: 1856px;
  }
}
@media only screen and (max-width: 700px) {
  .Licenses_container__812FI {
    padding: 0 16rem;
  }
}
@media only screen and (max-width: 700px) {
  .Licenses_container__812FI {
    margin: 48rem auto;
  }
}

.Licenses_title__8pP-k {
  display: inline;
  gap: 24rem;
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 72rem;
  line-height: 82rem;
  color: #1d2939;
}
.Licenses_title__8pP-k img {
  height: 68rem;
  width: 68rem;
  margin-right: 12rem;
}
@media only screen and (max-width: 700px) {
  .Licenses_title__8pP-k img {
    height: 42rem;
    width: 42rem;
  }
}
@media only screen and (max-width: 700px) {
  .Licenses_title__8pP-k {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 32rem;
    line-height: 42rem;
    color: #1d2939;
  }
}

.Licenses_content__4upYE {
  display: flex;
  align-items: center;
  gap: 42rem;
  margin-top: 32px;
}
@media only screen and (max-width: 700px) {
  .Licenses_content__4upYE {
    gap: 32rem;
    flex-direction: column-reverse;
  }
}

.Licenses_text__f4t-n {
  display: flex;
  flex-direction: column;
  padding: 0 130rem;
}
.Licenses_text__f4t-n * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24rem;
  line-height: 32rem;
  color: #101828;
}
.Licenses_text__f4t-n strong, .Licenses_text__f4t-n b {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24rem;
  line-height: 32rem;
  color: #101828;
}
.Licenses_text__f4t-n ol, .Licenses_text__f4t-n ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;
}
.Licenses_text__f4t-n li {
  margin-bottom: 24px;
}
.Licenses_text__f4t-n li:last-child {
  margin-bottom: 0;
}
.Licenses_text__f4t-n ul li {
  position: relative;
  list-style: none;
}
.Licenses_text__f4t-n ul li::before {
  content: "";
  display: block;
  position: absolute;
  top: 10px;
  left: -28px;
  height: 12px;
  width: 12px;
  background-color: #47C4F0;
  border-radius: 6px;
}
@media only screen and (max-width: 700px) {
  .Licenses_text__f4t-n {
    padding: 0;
  }
  .Licenses_text__f4t-n * {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16rem;
    line-height: 24rem;
    color: #101828;
  }
  .Licenses_text__f4t-n strong, .Licenses_text__f4t-n b {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16rem;
    line-height: 24rem;
    color: #101828;
  }
}

.Licenses_image__BCuXm {
  width: 900rem;
  height: 506rem;
  object-fit: cover;
  object-position: center;
  border-radius: 8rem;
  flex: none;
}
@media only screen and (max-width: 700px) {
  .Licenses_image__BCuXm {
    width: 100%;
    height: auto;
    aspect-ratio: 900/506;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Licenses/styles/Licenses.module.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,UAAA;EC0BA,yBDzBmB;EC0BnB,WAAA;EACA,eAAA;AD3BF;AC4BE;ED/BF;ICgCI,aAAA;EDzBF;AACF;AC+HE;EDvIF;ICoCI,gBAAA;EDxBF;AACF;AC0HE;EDvIF;IAKI,kBAAA;EAYF;AACF;;AATA;EC8CE,eAAA;EACA,UAAA;EAxDA,oCCHW;EDIX,kBAAA;EACA,gBAkEgC;EAjEhC,gBAAA;EACA,kBAAA;EACA,cCKS;AFmBX;AC6BE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AD3BJ;ACqGE;EA7EA;IAKI,aAAA;IACA,YAAA;EDzBJ;AACF;AC+FE;ED9HF;ICTE,oCCHW;IDIX,kBAAA;IACA,gBAoEkC;IAnElC,gBAAA;IACA,kBAAA;IACA,cCKS;EFuCT;AACF;;AArCA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AAwCF;AC8EE;ED1HF;IAMI,UAAA;IACA,8BAAA;EA0CF;AACF;;AAvCA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AA0CF;AAxCE;EC7BA,iCCFU;EDGV,kBAAA;EACA,gBAH0D;EAI1D,gBAAA;EACA,kBAAA;EACA,cCMS;AFkEX;AA5CE;ECjCA,iCCFU;EDGV,kBAAA;EACA,gBDgCkC;EC/BlC,gBAAA;EACA,kBAAA;EACA,cCMS;AF0EX;AAhDE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAkDJ;AA/CE;EACE,mBAAA;AAiDJ;AA/CI;EACE,gBAAA;AAiDN;AA5CE;EACE,kBAAA;EACA,gBAAA;AA8CJ;AA5CI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBEnDC;EFoDD,kBAAA;AA8CN;ACuBE;ED/GF;IA+CI,UAAA;EA6CF;EA5CE;ICxEF,iCCFU;IDGV,kBAAA;IACA,gBAH0D;IAI1D,gBAAA;IACA,kBAAA;IACA,cCMS;EFiHT;EAjDE;IC3EF,iCCFU;IDGV,kBAAA;IACA,gBD0EoC;ICzEpC,gBAAA;IACA,kBAAA;IACA,cCMS;EFyHT;AACF;;AApDA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAuDF;ACPE;EDtDF;IAQI,WAAA;IACA,YAAA;IACA,qBAAA;EAyDF;AACF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.container {\n  position: relative;\n  z-index: 2;\n  @include container(68rem auto 162rem);\n  @include mobile {\n    margin: 48rem auto;\n  }\n}\n\n.title {\n  @include sectionHeader;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  gap: 42rem;\n  margin-top: 32px;\n  @include mobile {\n    gap: 32rem;\n    flex-direction: column-reverse;\n  }\n}\n\n.text {\n  display: flex;\n  flex-direction: column;\n  padding: 0 130rem;\n\n  & * {\n    @include fnt(24, 32, $gray-900);\n  }\n\n  strong, b {\n    @include fnt(24, 32, $gray-900, 600);\n  }\n\n  ol, ul {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 0 24px;\n  }\n\n  li {\n    margin-bottom: 24px;\n\n    &:last-child {\n      margin-bottom: 0\n    }\n  }\n\n\n  ul li {\n    position: relative;\n    list-style: none;\n\n    &::before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 10px;\n      left: -28px;\n      height: 12px;\n      width: 12px;\n      background-color: $main;\n      border-radius: 6px;\n    }\n  }\n\n  @include mobile {\n    padding: 0;\n    & * {\n      @include fnt(16, 24, $gray-900);\n    }\n    strong, b {\n      @include fnt(16, 24, $gray-900, 600);\n    }\n  }\n}\n\n.image {\n  width: 900rem;\n  height: 506rem;\n  object-fit: cover;\n  object-position: center;\n  border-radius: 8rem;\n  flex: none;\n  @include mobile {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 900 / 506;\n  }\n}","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Licenses_container__812FI`,
	"title": `Licenses_title__8pP-k`,
	"content": `Licenses_content__4upYE`,
	"text": `Licenses_text__f4t-n`,
	"image": `Licenses_image__BCuXm`
};
export default ___CSS_LOADER_EXPORT___;
